/**
 * Sysadmin Library — /sysadmin/library/document-folders redirect (Library-PR-X2).
 *
 * The pre-X2 Doc Folders entity-tab has been collapsed into the unified
 * Documents tab. Since decision 18 the System Library has one folder set,
 * listed once in the Folder filter Select on the Documents page. This route
 * 302-redirects to keep legacy bookmarks working.
 */

import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/sysadmin/library/document-folders')({
  beforeLoad: () => {
    throw redirect({ to: '/sysadmin/library/documents', replace: true });
  },
});
